/** Shared Doc PopUp chrome: always show close (X) alongside action buttons. */
export const DOCUMENT_CHECK_PREVIEW_MODAL_UI = {
  showCloseButton: true,
  closeOnlyViaActions: false,
  allowBackdropClose: true,
} as const;
